import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import PropositionsManager from './PropositionsManager';

const PropositionsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Button
              variant="ghost"
              onClick={() => navigate('/dashboard')}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
            >
              <ArrowLeft className="w-4 h-4" />
              Retour au dashboard
            </Button>
            
            <h1 className="text-xl font-semibold text-gray-900">
              Gestion des Propositions d'Ordre du Jour
            </h1>
            
            <div className="w-32"></div> {/* Spacer for center alignment */}
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Collecte des Propositions
            </h2>
            <p className="text-gray-600">
              Gérez les sessions de collecte des propositions d'ordre du jour pour vos comités.
            </p>
          </div>
          
          {/* Propositions Manager Component */}
          <PropositionsManager />
        </div>
      </div>
    </div>
  );
};

export default PropositionsPage;